'use client';

var s = {"inputWrapper":"input-module_inputWrapper__3YvBT","clearValue":"input-module_clearValue__krWnE","inputWrapperIcon":"input-module_inputWrapperIcon__1xOnT","input":"input-module_input__3wsvS","removeIcon":"input-module_removeIcon__1ECIm","labelWrapper":"input-module_labelWrapper__1RHjc","inputError":"input-module_inputError__3I3tm","inputRecommendation":"input-module_inputRecommendation__3V5nQ","listRecommend":"input-module_listRecommend__3k1K3","activeRecommendedItem":"input-module_activeRecommendedItem__1Hyte"};

export { s as default };
//# sourceMappingURL=input.module.css.js.map
